export default __webpack_public_path__ + "static/media/FinanceTeacher.786a395c.jpg";